<div class="not-found" *ngIf="notFoundMessage">{{notFoundMessage}}</div>

<mat-card [class]='sourceDialog ? "diaglog-table" : "table"' [style]="getTableStyle()">
    <div class="table-responsive">
        <mat-table [dataSource]="dataSource" matSort matSortActive="inceptionDate" matSortDirection="asc"
            matSortDisableClear>

            <ng-container matColumnDef="bordereauReference">
                <mat-header-cell *matHeaderCellDef> Bordereau Reference</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Static text to be displayed for all rows of data.  -->
                    <!-- KAM Family -->
                    <div class="ellipsis"> {{row.bordereauReference}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="agencyName">
                <mat-header-cell *matHeaderCellDef> Agency Name</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Static text to be displayed for all rows of data.  -->
                    <!-- Stattic text "Kindertons Limited" -->
                    <div class="ellipsis"> {{row.agencyName}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="agencyNumber">
                <mat-header-cell *matHeaderCellDef> Agency Number</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Static text "10706" -->
                    <div class="ellipsis"> {{row.agencyNumber}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="localSubProducersName">
                <mat-header-cell *matHeaderCellDef> Local sub producers Name</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Policy Hub field “Broker Branch” - get this from broker branch table -->
                    <div class="ellipsis"> {{row.localSubProducersName}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="localSubProducersNumber">
                <mat-header-cell *matHeaderCellDef> Local sub producers Number</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Original branch ID from the broker branch table -->
                    <div class="ellipsis"> {{row.localSubProducersNumber}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="contractName">
                <mat-header-cell *matHeaderCellDef> Contract Name</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Policy Hub field “Product” - Currently used in declaration reports as a filter. FLEI -->
                    <div class="ellipsis"> {{row.contractName}}</div>
                </mat-cell>
            </ng-container>

            <!-- Contract Number -->
            <ng-container matColumnDef="contractNumber">
                <mat-header-cell *matHeaderCellDef> Contract Number </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.contractNumber}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="sectionName">
                <mat-header-cell *matHeaderCellDef> Section Name </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- static text  - "Contract still TBC" -->
                    <div class="ellipsis"> {{row.sectionName}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="reportingPeriodStartDate">
                <mat-header-cell *matHeaderCellDef> Reporting Period Start Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- This is the date used to filter transactions when a user enters a “Date From” value in the report search criteria.  -->
                    <div class="ellipsis"> {{row.reportingPeriodStartDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="reportingPeriodEndDate">
                <!-- This is the date used to filter transactions when a user enters a “Date To” value in the report search criteria.  -->
                <mat-header-cell *matHeaderCellDef> Reporting Period End Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.reportingPeriodEndDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="certificateNumber">
                <mat-header-cell *matHeaderCellDef> Policy Number </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.certificateNumber}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="inceptionDate">
                <mat-header-cell *matHeaderCellDef> Risk Inception Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.inceptionDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="expiryDate">
                <mat-header-cell *matHeaderCellDef> Risk Expiry Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.expiryDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="originalInceptionDate">
                <mat-header-cell *matHeaderCellDef> Original Inception Date </mat-header-cell>
                <mat-cell *matCellDef="let row">

                    <!-- Field must be dynamic, based on the “Transaction Type”. 

                    Where “Transaction Type” = “NEW” or “MTA”: 
                    - Display “Inception Date”

                    Where “Transaction Type” = “CAN” or “REN”:
                    - Display “Inception Date” of the FIRST policy incepted for that product/customer. -->
                    <div class="ellipsis"> {{row.originalInceptionDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="effectiveDateOfTransaction">
                <mat-header-cell *matHeaderCellDef> Effective Date Of Transaction </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.effectiveDateOfTransaction | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="policyPurchaseDate">
                <mat-header-cell *matHeaderCellDef> Policy Purchase Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!--db field [CreationDate] -->
                    <div class="ellipsis"> {{row.policyPurchaseDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="policyIssuanceDate">
                <mat-header-cell *matHeaderCellDef> Policy Issuance Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Static Text - 01/01/1900-->
                    <div class="ellipsis"> {{row.policyIssuanceDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="riskTransactionType">
                <mat-header-cell *matHeaderCellDef> Risk, Transaction Type </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Field must be dynamic, based on the “Transaction Type”. 

                    Where “Transaction Type” = 
                    “NEW” - Display “NEW”
                    “REN” - Display “RENEWAL”
                    “CAN” - Display “CANCELLATION”
                    “MTA” - Display “AMENDMENT” -->
                    <div class="ellipsis"> {{row.riskTransactionType}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="transactionTypeOriginalPremiumEtc">
                <mat-header-cell *matHeaderCellDef> Transaction Type - Original Premium etc. </mat-header-cell>
                <mat-cell *matCellDef="let row">

                    <!-- Field must be dynamic, based on the “Transaction Type”. 

                    Where “Transaction Type” = 
                    “NEW” - Display “Original Premium”
                    “REN” - Display “Original Premium”
                    “CAN” - Display “Cancellation”
                    “MTA” - Display “Mid-Term Adjustment - No Pricing Applied” -->

                    <div class="ellipsis"> {{row.transactionTypeOriginalPremiumEtc}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cancellationDate">
                <mat-header-cell *matHeaderCellDef> Cancellation Date </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.cancellationDate | date: appConstants.dateConfig.date}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cancellationReason">
                <mat-header-cell *matHeaderCellDef> Cancellation Reason </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.cancellationReason}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="numberOfInstalments">
                <mat-header-cell *matHeaderCellDef> Number Of Instalments </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Static text - "1" -->
                    <div class="ellipsis"> {{row.numberOfInstalments}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="instalmentBasis">
                <mat-header-cell *matHeaderCellDef> Instalment Basis </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- static text - "Monthly" -->
                    <div class="ellipsis"> {{row.instalmentBasis}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="policyDuration">
                <mat-header-cell *matHeaderCellDef> Policy Duration </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- static text - "Annual" -->
                    <div class="ellipsis"> {{row.policyDuration}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="methodOfSale">
                <mat-header-cell *matHeaderCellDef> Method of Sale </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- static text -"Add On" -->
                    <div class="ellipsis"> {{row.methodOfSale}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="insuredFirstName">
                <mat-header-cell *matHeaderCellDef>Insured FirstName </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- [Policy Holder] - First Name Only -->
                    <div class="ellipsis"> {{row.insuredFirstName}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="insuredFullNameLastNameOrCompanyName">
                <mat-header-cell *matHeaderCellDef>Insured Full Name, Last Name or Company Name </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- [Policy Holder] - Last Name Only, OR Company Name -->
                    <div class="ellipsis"> {{row.insuredLastNameOrCompanyName}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="insuredPolicyholderType">
                <mat-header-cell *matHeaderCellDef>Insured - Policyholder Type </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- static text - "Not Available" -->
                    <div class="ellipsis"> {{row.insuredPolicyholderType}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="isAReasonableAdjustmentRequired">
                <mat-header-cell *matHeaderCellDef>Is A Reasonable Adjustment Required </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- static text - "Not Available" -->
                    <div class="ellipsis"> {{row.isAReasonableAdjustmentRequired}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="identifiedLedBy">
                <mat-header-cell *matHeaderCellDef>Identified / Led By</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- null no data Required -->
                    <div class="ellipsis"> {{row.identifiedLedBy}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="health">
                <mat-header-cell *matHeaderCellDef>Health</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- null no data Required -->
                    <div class="ellipsis"> {{row.health}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="lifeEvent">
                <mat-header-cell *matHeaderCellDef>Life Event</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- null no data Required -->
                    <div class="ellipsis"> {{row.lifeEvent}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="resilience">
                <mat-header-cell *matHeaderCellDef>Resilience</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- null no data Required -->
                    <div class="ellipsis"> {{row.resilience}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="capability">
                <mat-header-cell *matHeaderCellDef>Capability</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- null no data Required -->
                    <div class="ellipsis"> {{row.capability}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="reasonableAdustmentMade">
                <mat-header-cell *matHeaderCellDef>Reasonable Adustment Made</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- null no data Required -->
                    <div class="ellipsis"> {{row.reasonableAdustmentMade}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="insuredAddress">
                <mat-header-cell *matHeaderCellDef>Insured Address</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Address line 1, 2 & 3 ONLY -->
                    <div class="ellipsis"> {{row.insuredAddress}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="insuredPostcode">
                <mat-header-cell *matHeaderCellDef>Insured Postcode</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- [Post Code] -->
                    <div class="ellipsis"> {{row.postcode}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="insuredCountry">
                <!-- [Country] -->
                <mat-header-cell *matHeaderCellDef>Insured Country</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.country}}</div>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="locationOfRiskAddress">
                <mat-header-cell *matHeaderCellDef>Location of Risk, Address</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Address line 1, 2 & 3 ONLY -->
                    <div class="ellipsis"> {{row.locationOfRiskAddress}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="locationOfRiskPostcode">
                <mat-header-cell *matHeaderCellDef>Location of Risk, Postcode </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.postcode}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="locationOfRiskCountry">
                <mat-header-cell *matHeaderCellDef>Location of risk - Country </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.country}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="numberOfBedrooms">
                <mat-header-cell *matHeaderCellDef>Number Of Bedrooms </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.numberOfBedrooms}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="previousClaims">
                <mat-header-cell *matHeaderCellDef>Previous Claims </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.previousClaims}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="referredToArc">
                <mat-header-cell *matHeaderCellDef>Referred to Arc</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.referredToArc}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="referralReference">
                <mat-header-cell *matHeaderCellDef>Referral Reference</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.referralReference}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="referralReason">
                <mat-header-cell *matHeaderCellDef>Referral Reason</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.referralReason}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="grossPremiumPaidThisTime">
                <mat-header-cell *matHeaderCellDef>Gross premium paid this time</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.grossPremium | number:'1.2-2'}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="commission">
                <mat-header-cell *matHeaderCellDef>Commission %</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.commission}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="commissionAmount">
                <!-- [Intermediary Commission] -->
                <mat-header-cell *matHeaderCellDef>Commission Amount</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.intermediaryCommission | number:'1.2-2'}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="localSubProducersCommission">
                <mat-header-cell *matHeaderCellDef>Local sub producers commission %</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.localSubProducersCommission}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="localSubProducersCommissionAmount">
                <mat-header-cell *matHeaderCellDef>Local sub producers commission amount</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.localSubProducersCommissionAmount}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="otherFeesOrDeductionsDescription">
                <mat-header-cell *matHeaderCellDef>Other Fees or Deductions Description</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.otherFeesOrDeductionsDescription}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="otherFeesOrDeductionsAmount">
                <mat-header-cell *matHeaderCellDef>Other Fees or Deductions Amount</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- Null - no data required -->
                    <div class="ellipsis"> {{row.otherFeesOrDeductionsAmount}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="totalPaidToArc">
                <mat-header-cell *matHeaderCellDef>Total Paid to Arc</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="ellipsis"> {{row.totalAmountPayable | number:'1.2-2'}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tax1JurisdictionCountryStateProvinceTerritory">
                <mat-header-cell *matHeaderCellDef>Tax 1 - Jurisdiction: Country, State, Province,
                    Territory</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- country code derived from postcode: GB, JE, GG, IM or BF -->
                    <div class="ellipsis"> {{row.tax1JurisdictionCountryStateProvinceTerritory}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tax1TaxType">
                <mat-header-cell *matHeaderCellDef>Tax 1 - Tax Type</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- "Insurance Premium Tax" -->
                    <div class="ellipsis"> {{row.tax1TaxType}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tax1AmountOfTaxablePremium">
                <mat-header-cell *matHeaderCellDef>Tax 1 - Amount of Taxable Premium</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- [Net Premium] -->
                    <div class="ellipsis"> {{row.netPremium | number:'1.2-2'}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tax1">
                <mat-header-cell *matHeaderCellDef>Tax 1 - %</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- [IPT Rate] -->
                    <div class="ellipsis"> {{row.iptRate | number:'1.2-2'}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tax1Amount">
                <mat-header-cell *matHeaderCellDef>Tax 1 - Amount</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <!-- [Total IPT] -->
                    <div class="ellipsis"> {{row.totalIPT | number:'1.2-2'}}</div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row matRipple
                [ngClass]="row.isHaveNegativeLine ? row.transactionType == transactionType.CANX ? 'canx-row': 'new-row':''"
                *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <div class="display-flex flex-direction-row footer">
        <div class="btn-group flex-50">
            <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
                matTooltip="Export to Excel" mat-raised-button color="primary" (click)="exportExcel()">
                Export to Excel
            </button>
            <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
                matTooltip="Export to CSV" mat-raised-button color="primary" (click)="exportCsv()">
                Export to CSV
            </button>
            <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
                matTooltip="Export to PDF" mat-raised-button color="primary" (click)="exportPdf()">
                Export to PDF
            </button>
        </div>

        <div class="paging flex-50">
            <mat-paginator [length]="totalRows" [pageIndex]="pagingConstant.pageIndex"
                [pageSize]="pagingConstant.pageSizeLarger" [pageSizeOptions]="pagingConstant.pageSizeOptionsLarger"
                showFirstLastButtons>
            </mat-paginator>
        </div>
    </div>
</mat-card>